var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: 'Go to Business Dashboard' }),expression:"{ content: 'Go to Business Dashboard' }"}]},[_c('router-link',{staticClass:"switch-business",attrs:{"to":{ name: _vm.getRouteName() }}},[_c('RepeatIcon',{staticClass:"switch-business__icon"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }